package org.hs_soft.runmynesto.pages.home.sub_page.user.component

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.dialog.dialog.AddRecordDialog
import org.hs_soft.runmynesto.pages.components.dialog.dialog.ErrorMsgDialog
import org.hs_soft.runmynesto.pages.home.sub_page.user.mvi.UserEvent
import org.hs_soft.runmynesto.pages.home.sub_page.user.mvi.UserState


@Composable
fun UserDialog(
    state: UserState,
    event:(UserEvent)->Unit,
    windowSizeMode: WindowSizeModeEnum
) {

    if (state.showAddRecordDialog) {
        AddRecordDialog(
            windowSizeMode = windowSizeMode,
            dialogTitle = Strings.current().addNewUser,
            nameFieldTitle = Strings.current().name,
            numberFieldTitle = Strings.current().number,
            nameValue = state.newRecordName,
            nameHint = Strings.current().enterUserName,
            numberHint = Strings.current().enterUserNumber,
            showNumberField =true,
            numberValue = state.newRecordNumber,
            isSubmitClickable = state.isAddNewRecordSubmitClickable,
            loading = state.addNewUserLoading,
            onNumberValueChange = {
                event(UserEvent.OnChangeRecordNumber(it))
            },
            onNameValueChange = {
                event(UserEvent.OnChangeRecordName(it))
            },
            onCancelClick = {
                event(UserEvent.OnCancelAddNewUserDialogClick)
            },
            onSubmitClick = {
                event(UserEvent.OnSubmitAddNewUserDialogClick(windowSizeMode))
            },
            onBackgroundClick = {
                event(UserEvent.OnCancelAddNewUserDialogClick)
            }
        )
    }

    if (state.errorInfo!=null){
        ErrorMsgDialog(
            windowSizeMode=windowSizeMode,
            description =state.errorInfo,
            onDismissDialog = {
                event(UserEvent.DismissErrorDialog)
            }
        )
    }
}